import {
  getSummary,
  getCompanyReturns,
} from '@/pages/CompanyReport/redux/selectors';
import { getIndustryPerformance } from '@ducks/averages/selectors';
import { pathConstructor } from '@/hooks/useCompany/utils';
import type { State as CompanyState } from '@/pages/CompanyReport/redux/interface';
import type { LocationState } from 'redux-first-router';

interface ReduxState {
  company: CompanyState;
  location: LocationState;
}

export default function selector(state: ReduxState) {
  const path = pathConstructor(state.location);
  const companyReturnsSelector = getCompanyReturns();
  const performanceSelector = getIndustryPerformance();
  const companyId = state.company.urlToIdMapping[path];
  const { market, industry } = performanceSelector(state, {
    companyId,
  });

  const companyPerformance = companyReturnsSelector(state, {
    companyId,
  });
  const summary = getSummary(state, { companyId });
  return {
    companyPerformance: companyPerformance,
    industryPerformance: industry,
    marketPerformance: market,
    name: summary.shortName,
    uniqueSymbol: summary.uniqueSymbol,
    tickerSymbol: summary.tickerSymbol,
    exchangeCountryISO: summary.exchangeCountryISO as string,
    country: summary.countryISO as string,
    industryName: summary.industryData.secondaryName,
    leveredBeta: industry?.leveredBeta,
  };
}
